export default "__VITE_PUBLIC_ASSET__8d0141cf__"